
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { useDeepLinks } from '@/hooks/use-deep-links';
import { useNetworkSync } from '@/hooks/use-network-sync';
import NetworkProvider from './components/NetworkProvider';
import OnboardingTour from './components/onboarding/OnboardingTour';
import { TourProvider } from './components/onboarding/TourContext';
import Home from './pages/Home';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import NoteEditor from './components/NoteEditor';
import SharedNoteView from './components/SharedNoteView';
import EmailVerified from './pages/EmailVerified';
import EmailConfirmed from './pages/EmailConfirmed';
import ResetPassword from './pages/ResetPassword';
import Subscription from './pages/Subscription';

function App() {
  // Use our custom hooks to manage state and side effects
  const { isAuthenticated } = useAuth();
  const { handleVerificationRedirect } = useDeepLinks();
  const { isAppOnline } = useNetworkSync();

  // Show loading state while authentication state is being determined
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return (
    <NetworkProvider>
      <TourProvider>
        {isAuthenticated && <OnboardingTour />}
        <Routes>
          <Route 
            path="/" 
            element={isAuthenticated ? <Home isOnline={isAppOnline} /> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/auth" 
            element={!isAuthenticated ? <Auth /> : <Navigate to="/" replace />} 
          />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route 
            path="/editor" 
            element={isAuthenticated ? <NoteEditor isOnline={isAppOnline} /> : <Navigate to="/auth" replace />} 
          />
          <Route path="/share/:shareId" element={<SharedNoteView />} />
          <Route path="/email-verified" element={<EmailVerified />} />
          <Route path="/email-confirmed" element={<EmailConfirmed />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route 
            path="/subscription" 
            element={isAuthenticated ? <Subscription /> : <Navigate to="/auth" replace />} 
          />
          <Route path="*" element={<Navigate to="/auth" replace />} />
        </Routes>
      </TourProvider>
    </NetworkProvider>
  );
}

export default App;
